import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './HpRespLocationsModuleItemList.scss';
import { trackShopByLocationClick } from '../helpers/shopByTracking';
import { slugify } from '../../utils/slugify';
import { SeoLink } from 'dibs-seo/exports/SeoLink';

function HpRespLocationsModuleItemList({ location, ipLink, additionalTopSpacing }) {
    const locationItems = location.items.filter(({ linkData }) => linkData.path !== ipLink);
    const containerClasses = classnames('colXs12 colLg3', {
        [styles.additionalTopSpacing]: additionalTopSpacing,
    });

    return (
        <div className={containerClasses}>
            <div className={styles.image} style={{ backgroundImage: `url(${location.imageUrl})` }}>
                <ul className={styles.locationsList}>
                    {locationItems.map((item, index) => (
                        <li
                            key={item.cmsId}
                            data-tn={`dealer-location-${slugify(item.title)}`}
                            className={styles.locationItem}
                        >
                            <SeoLink
                                linkData={item.linkData}
                                className={styles.locationLink}
                                onClick={() => trackShopByLocationClick(item, index)}
                            >
                                {item.title}
                            </SeoLink>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

HpRespLocationsModuleItemList.propTypes = {
    additionalTopSpacing: PropTypes.bool,
    location: PropTypes.object,
    ipLink: PropTypes.string,
};

export { HpRespLocationsModuleItemList };
